import { InfoButton } from '@etg/wings';
import type {
  BoundNew,
  BrandedFare,
  PaymentMethodPrice,
  TravelerNew,
  TravelerPrice,
} from '@eti/schema-types';
import { useTranslation } from '@eti/providers';
import type { AncillaryBundleOptionType } from '../../../../common/utils/models';
import { PriceInformationModal } from './PriceInformationModal';

interface PriceInformationProps {
  bounds: BoundNew[];
  discountAmount: number;
  finalProductIdsToPurchase?: number[];
  handleClose: () => void;
  handleOpen: () => void;
  isOpen: boolean;
  paymentMethodPrices: PaymentMethodPrice[];
  selectedBundleOption?: AncillaryBundleOptionType;
  selectedFare?: BrandedFare;
  travelerPrices: TravelerPrice[];
  travelerPricesWithoutDiscounts: TravelerPrice[];
  tripTravelers: TravelerNew[];
}

export const PriceInformation = ({
  bounds,
  discountAmount,
  finalProductIdsToPurchase = [],
  handleClose,
  handleOpen,
  isOpen,
  paymentMethodPrices,
  selectedBundleOption,
  selectedFare,
  travelerPrices,
  travelerPricesWithoutDiscounts,
  tripTravelers,
}: PriceInformationProps) => {
  const { t } = useTranslation();
  const infoButtonLabel = t('ScreenReader.PriceSpecification.InfoButton');

  return (
    <>
      <InfoButton
        data-testid="price-specification-info-button"
        label={infoButtonLabel}
        onClick={handleOpen}
      />
      <PriceInformationModal
        bounds={bounds}
        discountAmount={discountAmount}
        finalProductIdsToPurchase={finalProductIdsToPurchase}
        handleClose={handleClose}
        isOpen={isOpen}
        paymentMethodPrices={paymentMethodPrices}
        selectedBundleOption={selectedBundleOption}
        selectedFare={selectedFare}
        travelerPrices={travelerPrices}
        travelerPricesWithoutDiscounts={travelerPricesWithoutDiscounts}
        tripTravelers={tripTravelers}
      />
    </>
  );
};
